<template>
  <div class="header sticky">
    <div class="container">
      <img @click="$router.push('/')" src="@/assets/logo-fdci.png" alt="" class="logo">
      <!-- <div style="float:right">
        <img src="@/assets/icons/docente.svg" alt="">
        Juan Alderete
      </div> -->

      <el-popover placement="top-start" title="" width="200" trigger="hover"
        content="Acceda a su Espacio de Formación Personal" v-if="!$isMobile() && !userData">

        <avatar slot="reference" fullname="ESPACIO F PERSONAL" @click.native="acceder" class="avatarLog" :size="55">
        </avatar>

      </el-popover>


      <avatar slot="reference" :fullname="userData.nombre + ' ' + userData.apellido"
        v-if="!$isMobile() && userData && !userData.force_pass" class="avatarLog" :size="55" @click.native="acceder">
      </avatar>


      <img src="@/assets/superior.png" v-if="!$isMobile()" @click="open"
        style="float:right; margin-right:30px; cursor:pointer" alt="">

    </div>
    
    <nav class="main-menu" v-if="!$isMobile()">
      <div class="container">
        <ul>
          <li><router-link :to="$route.name === 'home' ? '' : '/'">Inicio</router-link></li>
          <li v-if="!$isMobile()"><a href="https://des-tuc.infd.edu.ar/sitio/" target="_blank">Dirección de Nivel
              Superior</a></li>
         <li v-if="!$isMobile()" class="has-submenu">
            <a href="javascript:void(0)">Aulas Virtuales</a>
            <ul class="submenu">
              <li>
                <a href="https://tucuman.digitalhouse.com/" target="_blank">
                  Aula Virtual IA y Congreso
                </a>
              </li>
              <li>
                <a href="https://aulas.educaciontuc.gov.ar/" target="_blank">
                  Aula Virtual FDCI
                </a>
              </li>
            </ul>
          </li>
          <li v-if="!$isMobile()"><router-link :to="userData ? { name: 'homeDocente' } : { name: 'docentes' }">Espacio
              de formación personal
            </router-link></li>
          <li><router-link to="/deberes-y-derechos-fdci">Normativa</router-link></li> 
          <!-- <li><router-link to="/contacto">Contacto</router-link></li> -->
      </ul>
      </div>
    </nav> 

   

    <!-- MENU PARA MOVIL -->
<div class="menu-movil" v-if="$isMobile()">
  <el-button type="primary" @click="mostrarMenu = !mostrarMenu" icon="el-icon-menu">
    Menú
  </el-button>

  <el-dialog 
    :visible.sync="mostrarMenu" 
    fullscreen 
    :show-close="true" 
    custom-class="menu-dialog" 
    :modal="false"
    :append-to-body="true"
  >
    <div class="menu-contenido">
      <img @click="$router.push('/')" src="@/assets/logo-fdci.png" alt="" class="logo-movil">
      <ul>
        <li>
          <router-link :to="$route.name === 'home' ? '' : '/'" @click.native="mostrarMenu = false">
            Inicio
          </router-link>
        </li>

        <li>
          <a href="https://des-tuc.infd.edu.ar/sitio/" target="_blank" @click="mostrarMenu = false">
            Dirección de Nivel Superior
          </a>
        </li>

        <!-- SUBMENÚ AULAS VIRTUALES -->
        <li>
          <div @click="submenuAulas = !submenuAulas" class="submenu-header">
            <span>Aulas Virtuales</span>
            <i :class="submenuAulas ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <ul v-show="submenuAulas" class="submenu">
            <li>
              <a href="https://tucuman.digitalhouse.com/" target="_blank" @click="mostrarMenu = false">
                Aula Virtual IA y Congreso
              </a>
            </li>
            <li>
              <a href="https://aulas.educaciontuc.gov.ar/" target="_blank" @click="mostrarMenu = false">
                Aula Virtual FDCI
              </a>
            </li>
            
          </ul>
        </li>
        <!-- FIN SUBMENÚ -->

        <li>
          <router-link :to="userData ? { name: 'homeDocente' } : { name: 'docentes' }"
            @click.native="mostrarMenu = false">
            Espacio de Formación Personal
          </router-link>
        </li>

        <li>
          <router-link to="/deberes-y-derechos-fdci" @click.native="mostrarMenu = false">
            Normativa
          </router-link>
        </li>
      </ul>

      <div class="menu-footer">
        <img src="@/assets/superior.png" @click="open" style=" height:40px;cursor:pointer" alt="">

        <el-button type="danger" @click="mostrarMenu = false" icon="el-icon-close">
          Regresar
        </el-button>
      </div>
    </div>
  </el-dialog>
</div>
<!-- FIN DEL MENU MOVIL -->




  
    <div v-if="mostrarNombreHeader && $route.name === 'detalleCapa'">
      <div class="container">
        <h1 class="nombre">{{ mostrarNombreHeader }}</h1>
      </div>

      <MenuMovil :offset="'header'" v-if="$isMobile()" />


    </div>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus"
import Avatar from 'vue-avatar-component'
import MenuMovil from '@/components/capacitacion/MenuMovil.vue'

export default {
  components: { Avatar, MenuMovil },
  data() {
    return {
      mostrarMensaje: true,
      userData: window.sessionStorage.getItem('userData') && JSON.parse(window.sessionStorage.getItem('userData')) ? JSON.parse(window.sessionStorage.getItem('userData')) : null,
      userDataCuil: window.localStorage.getItem('userDataCuil'),
      userDataPass: window.localStorage.getItem('userDataPass'),
      mostrarNombreHeader: false,
      menuMobil: 'detalles',

      mostrarMenu: false,
      submenuAulas: false,

    }
  },
  watch: {
    '$route': {
      handler(to, from) {
        this.userData = window.sessionStorage.getItem('userData') ? JSON.parse(window.sessionStorage.getItem('userData')) : null;
      },
      immediate: true
    }
  },
  mounted() {
    //agregar logica para mostrar mensaje de recuperacion de contraseña
    // this.mostrarMensaje = window.sessionStorage.getItem('userData')  ? JSON.parse(window.sessionStorage.getItem('userData')).mostrarMensaje : null;
  },
  created() {
    EventBus.$on('mostrarNombreHeader', (n) => {
      this.mostrarNombreHeader = n
    })



  },
  methods: {

    acceder() {
      if (this.$route.name !== 'docentes') {
        const userData = window.sessionStorage.getItem('userData')
        if (userData) {
          if (this.$route.name !== 'homeDocente')
            this.$router.push({ name: 'homeDocente' })
          // Si el usuario está logueado, lo redirigimos directamente a su espacio

        } else {
          // Si no está logueado, lo llevamos a la página de login
          this.$router.push({ name: 'docentes' })
        }
      }
    },
    open() {
      window.open('https://des-tuc.infd.edu.ar/sitio/', '_blank')
    }
  },
}
</script>

<style lang="scss" scoped>

.has-submenu {
  position: relative;

  a {
    cursor: pointer;
  }

  .submenu {
    display: none;
    position: absolute;
    top: 100%; // aparece debajo del item padre
    left: 0;
    background: #0b395d; // mismo fondo que tu menú principal
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 220px;
    border: 1px solid rgba(255, 255, 255, 0.2);

    li {
      display: block;
      margin: 0;

      a {
        display: block;
        padding: 10px 15px;
        font-size: 14px;
        color: #fff;
        text-decoration: none;

        &:hover {
          background: rgba(255, 255, 255, 0.15);
        }
      }
    }
  }

  &:hover .submenu {
    display: block;
  }
}




.alerta-trigger {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  display: inline-block;
  font-size: 11px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  i {
    font-size: 12px;
    vertical-align: middle;
  }
}

.alerta-content {
  padding: 0px 15px;
  margin-left: 15px;
  p {
    margin-left: 15px;
    line-height: 1.6;
    font-size: 14px;
 word-break: break-word;
  white-space: normal;
  overflow-wrap: anywhere;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    strong {
      color: #F26D22;
    }
  }
}

.btn-alerta-mail {
  float: right;
  padding: 4px 6px;
  margin-top: -4px
}

// Estilos globales para el popover de alerta
:deep(.alerta-popover) {
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 2px solid #F26D22;
  overflow: hidden;
  
  .el-popover__title {
    color: #F26D22;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 15px;
    text-align: center;
    padding: 15px 15px 0 15px;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 15px;
  }
  
  .el-popover__content {
    padding: 15px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .el-popover__arrow {
    border-color: #F26D22 !important;
    
    &::after {
      border-color: #F26D22 !important;
    }
  }
}

.nombre {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 10px 20px;
  background: #f1f1f16b;
  border-top: 1px solid #0b395d3d;
  border-bottom: 1px solid #0b395d26;
}

.nombre small {
  display: block;
}

.avatarLog {
  float: right;
  cursor: pointer;
  margin-top: 0px
}

.header {
  padding: 0px;
  padding-top: 10px;
  position: relative;
}

.header img {
  height: 60px;

}

.main-menu {
  background: #0b395d;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    padding: 6px;


    li {
      color: white;
      display: inline;
      margin-right: 20px;


      a {
        text-decoration: none;
        color: #FFF; // Example link color
        font-size: 14px;

      }
    }
  }
}

// Media query for smaller screens
@media (max-width: 768px) {
  .alerta-mail {
    background: #F26D22;
    font-size: 13px;
    padding: 12px;

    .el-button {
      display: block;
      margin-top: 10px;
    }
  }

  .btn-alerta-mail {
    float: right;
    padding: 4px 6px;
    margin-top: 10px
  }

  .header img {
    height: 50px;
    padding: 10px;

  }

  .main-menu {
    // display: none; // Hide the menu on small screens
  }

  .sticky {
    position: -webkit-sticky;
    /* Safari */
    position: sticky;
    top: 0;
    z-index: 1000;
    /* Para asegurarte de que quede encima de otros elementos */
    background-color: white;
    /* Opcional: puedes cambiar el fondo */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    /* Agrega una sombra para destacar el elemento */
  }

  .avatarLog {
    float: right;
    cursor: pointer;
    margin: 5px 10px
  }

  .container {
    flex-direction: column; // Stack items vertically on small screens
  }
}

.menu-movil {
  position: absolute;
  top: 20px;
  right: 10px;
  z-index: 2000;

  .el-button {
    background-color: #006eb9;
    color: white;
    font-weight: bold;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
  }
}

.menu-dialog {
  .menu-contenido {
    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        border-bottom: 1px solid #eee;

        a {
          display: block;
          padding: 15px 20px;
          font-size: 18px;
          color: #0b395d;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.3s ease;

          &:hover {
            background: #f5f5f5;
          }
        }
      }
    }
  }

  /* === SUBMENÚ AULAS VIRTUALES SOLO EN MÓVIL === */
  .submenu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    font-size: 18px;
    font-weight: 500;
    color: #0b395d;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: #f5f5f5;
    }

    i {
      font-size: 16px;
    }
  }

  .submenu {
    list-style: none;
    margin: 0;
    padding: 0;

    li a {
      display: block;
      padding: 12px 35px; // sangría mayor para diferenciar
      font-size: 16px;
      color: #0b395d;
      text-decoration: none;
      transition: all 0.3s ease;

      &:hover {
        background: #f9f9f9;
      }
    }
  }
}


.menu-dialog {
  .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #eee;
  }

  .menu-contenido {
    padding: 0;
    background-color: #ffffff;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      flex: 1;
      overflow-y: auto;

      li {
        margin: 0;
        text-align: left;
        border-bottom: 1px solid #eee;

        a {
          text-decoration: none;
          color: #0b395d;
          font-weight: 500;
          font-size: 18px;
          display: block;
          padding: 15px 20px;
          transition: all 0.3s ease;

          &:hover {
            background-color: #f5f5f5;
          }
        }
      }
    }

    .menu-footer {
      padding: 15px;
      text-align: center;
      border-top: 1px solid #eee;
      background: #fff;

      .el-button {
        width: 100%;
        padding: 12px;
        font-size: 16px;
        margin: 0;
      }
    }
  }
}

:deep(.el-dialog__wrapper) {
  background: transparent;
}

:deep(.el-dialog) {
  background-color: #ffffff;
  margin: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: none;
}

:deep(.el-dialog__body) {
  background-color: #ffffff;
  padding: 0;
  flex: 1;
  overflow: hidden;
}

:deep(.el-dialog__headerbtn .el-dialog__close) {
  color: #0b395d;
  font-size: 20px;
}

@media screen and (max-width: 768px) {
  .logo-movil {

    width: 100px;
    padding: 0px 10px;
  }

  ::v-deep .el-card__body {
    padding: 0 !important;
  }
}





</style>